import React from 'react';
import { motion } from 'framer-motion';
import { Bed, Bath, Square } from 'lucide-react';
import { Button } from './Button';
import { Card, CardContent } from './Card';
const listings = [{
  id: 1,
  image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: '$4,250,000',
  address: '1284 Modernist Way, Beverly Hills',
  beds: 5,
  baths: 6,
  sqft: '6,200'
}, {
  id: 2,
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: '$2,895,000',
  address: '842 Coastal Drive, Malibu',
  beds: 4,
  baths: 4.5,
  sqft: '4,100'
}, {
  id: 3,
  image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: '$1,950,000',
  address: '331 Skyline Blvd, Hollywood Hills',
  beds: 3,
  baths: 3,
  sqft: '2,850'
}];
export function FeaturedListings() {
  return <section id="listings" className="py-20 md:py-32 bg-charcoal" data-id="element-36">
      <div className="container mx-auto px-6" data-id="element-37">
        <div className="text-center mb-16" data-id="element-38">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="block text-gold font-heading text-sm uppercase tracking-widest font-semibold mb-4" data-id="element-39">
            On The Market
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl text-white uppercase tracking-wide" data-id="element-40">
            Featured Listings
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-41">
          {listings.map((listing, index) => <motion.div key={listing.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} data-id="element-42">
              <Card className="bg-white/5 border-none rounded-none overflow-hidden group" data-id="element-43">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-44">
                  <img src={listing.image} alt={listing.address} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-45" />
                  <div className="absolute top-4 right-4 bg-gold text-charcoal font-heading font-bold px-4 py-2 text-sm tracking-wider" data-id="element-46">
                    {listing.price}
                  </div>
                </div>
                <CardContent className="p-6" data-id="element-47">
                  <h3 className="font-heading text-lg text-white mb-4 truncate" data-id="element-48">
                    {listing.address}
                  </h3>
                  <div className="flex items-center gap-6 text-white/70 font-body text-sm mb-6" data-id="element-49">
                    <div className="flex items-center gap-2" data-id="element-50">
                      <Bed className="h-4 w-4 text-gold" data-id="element-51" />
                      <span data-id="element-52">{listing.beds} Beds</span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-53">
                      <Bath className="h-4 w-4 text-gold" data-id="element-54" />
                      <span data-id="element-55">{listing.baths} Baths</span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-56">
                      <Square className="h-4 w-4 text-gold" data-id="element-57" />
                      <span data-id="element-58">{listing.sqft} SqFt</span>
                    </div>
                  </div>
                  <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white hover:text-charcoal rounded-none h-12 bg-transparent" data-id="element-59">
                    View Details
                  </Button>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-60">
          <Button className="bg-gold hover:bg-gold-dark text-charcoal font-semibold rounded-none px-10 h-14 text-base w-full sm:w-auto" data-id="element-61">
            Browse All Listings
          </Button>
        </motion.div>
      </div>
    </section>;
}